import { render, staticRenderFns } from "./pll-figure.vue?vue&type=template&id=3505e288&"
import script from "./pll-figure.vue?vue&type=script&lang=js&"
export * from "./pll-figure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports